module.exports = __webpack_public_path__ + "img/pl5daily_icon.8016bdac.png";